/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { RESTService, ReduxUtils } from '@spm/core';
import models from './models';

/**
 * Post request to path:
 * /v1/ua/aces_create_pending_citizen_account
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const createPendingCitizenAccountUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_create_pending_citizen_account`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_email_password_reset
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const emailPasswordResetUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_email_password_reset`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESUserRegistrationResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Gets ACESEmailVerifiedDtls from api:
 * /v1/ua/aces_is_email_verified
 *
 * @param {any} callback function to call once this function has finished
 */
const isEmailVerifiedUtil = callback => {
  ReduxUtils.getModelDataFromRestAPI(
    callback,
    `v1/ua/aces_is_email_verified`,
    models.ACESEmailVerifiedDtls
  );
};

/**
 * Post request to path:
 * /v1/ua/aces_activate_email
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const activateEmailUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_activate_email`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESUserRegistrationResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_activation_link_email
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesActivationLinkEmailUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_activation_link_email`;

  RESTService.post(url, data, (success, response) => {
    callback(success, response);
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_activate_citizen_account
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesActivateCitizenAccountUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_activate_citizen_account`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESAccountActivationResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_resend_activation_link_email
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesResendActivationLinkEmailUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_resend_activation_link_email`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESAccountActivationResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_send_forgot_username_email
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesSendForgotUsernameEmailUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_send_forgot_username_email`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESUserRegistrationResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_account_unlock
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesAccountUnlockUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_account_unlock`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESAccountUnlockResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_check_account_enable
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesCheckAccountEnableUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_check_account_enable`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESAccountEnableResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

/**
 * Post request to path:
 * /v1/ua/aces_send_account_unlock_email
 *
 * @param {any} data
 * @param {any} callback function to call once this function has finished
 */
const postAcesSendAccountUnlockEmailUtil = (data = {}, callback) => {
  const url = `${process.env.REACT_APP_REST_URL}/v1/ua/aces_send_account_unlock_email`;

  RESTService.post(url, data, (success, response) => {
    if (success) {
      const model = new models.NewACESUserRegistrationResponseDtlsResponse(response);
      callback(success, model);
    } else {
      callback(success, response);
    }
  });
};

export {
  createPendingCitizenAccountUtil,
  emailPasswordResetUtil,
  isEmailVerifiedUtil,
  activateEmailUtil,
  postAcesActivationLinkEmailUtil,
  postAcesActivateCitizenAccountUtil,
  postAcesResendActivationLinkEmailUtil,
  postAcesSendForgotUsernameEmailUtil,
  postAcesAccountUnlockUtil,
  postAcesCheckAccountEnableUtil,
  postAcesSendAccountUnlockEmailUtil,
};
